import React from 'react';
import './FormInput.css';

const ContextInput = ({ value, onChange }) => {
  return (
    <div className="form-input-group">
      <label className="form-label">Context</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="form-textarea"
        placeholder="Provide relevant context or background information"
        rows="4"
      />
    </div>
  );
};

export default ContextInput;

